<template>
    <div>
        <h1>Broad</h1>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>
